// extracted by mini-css-extract-plugin
module.exports = {"footer":"AppFooter_footer_18KT2"};